import React from 'react';

export default function ThemeToggle({ darkTheme, onClick }) {
  const label = darkTheme ? 'Svijetla tema' : 'Tamna tema';
  return <button type="button" className="theme-toggle-btn" onClick={onClick} aria-label={label} title={label}>
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {darkTheme ? <><circle cx="12" cy="12" r="5" /><path d="M12 1v2m0 18v2M1 12h2m18 0h2M4.22 4.22l1.42 1.42m12.72 12.72 1.42 1.42M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" /></> : <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />}
    </svg>
  </button>;
}
